//Generate code_challenge and code_verified and store into local store

import pkceChallenge from 'pkce-challenge'

export function getChallenge() {

    const pkceCodeAndVerifier = pkceChallenge();

    localStorage.setItem("code_challenge", pkceCodeAndVerifier.code_challenge)
    localStorage.setItem("code_verifier", pkceCodeAndVerifier.code_verifier)
    return pkceCodeAndVerifier;
}

export function removeChallenge() {
    localStorage.removeItem("code_challenge")
    localStorage.removeItem("code_verifier")
}